import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/index.css";

import JoinScreen from "@/pages/student/JoinScreen";
import PlayArea from "@/pages/student/PlayArea";
import TeacherLogin from "@/pages/teacher/TeacherLogin";
import TeacherDashboard from "@/pages/teacher/TeacherDashboard";
import LiveSession from "@/pages/teacher/LiveSession";
import SessionReport from "@/pages/teacher/SessionReport";
import CmsList from "@/pages/teacher/CmsList";
import CmsWorkshopEdit from "@/pages/teacher/CmsWorkshopEdit";
import AdminLecturers from "@/pages/teacher/AdminLecturers";
import AdminNicknames from "@/pages/teacher/AdminNicknames";
import WorkshopPreview from "@/pages/teacher/WorkshopPreview";
import ProjectorMode from "@/pages/ProjectorMode";

function RequireTeacher({ children }) {
  const token = localStorage.getItem("dm_token");
  if (!token) return <Navigate to="/teacher/login" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="bottom-right" richColors />
      <Routes>
        <Route path="/" element={<JoinScreen />} />
        <Route path="/join/:code" element={<JoinScreen />} />
        <Route path="/play/:participantId" element={<PlayArea />} />
        <Route path="/teacher/login" element={<TeacherLogin />} />
        <Route path="/teacher" element={<RequireTeacher><TeacherDashboard /></RequireTeacher>} />
        <Route path="/teacher/session/:sessionId" element={<RequireTeacher><LiveSession /></RequireTeacher>} />
        <Route path="/teacher/session/:sessionId/report" element={<RequireTeacher><SessionReport /></RequireTeacher>} />
        <Route path="/teacher/cms" element={<RequireTeacher><CmsList /></RequireTeacher>} />
        <Route path="/teacher/cms/:workshopId" element={<RequireTeacher><CmsWorkshopEdit /></RequireTeacher>} />
        <Route path="/teacher/admin/lecturers" element={<RequireTeacher><AdminLecturers /></RequireTeacher>} />
        <Route path="/teacher/admin/nicknames" element={<RequireTeacher><AdminNicknames /></RequireTeacher>} />
        <Route path="/teacher/workshop-preview/:workshopId" element={<RequireTeacher><WorkshopPreview /></RequireTeacher>} />
        <Route path="/projector/:code" element={<ProjectorMode />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
